export const GET_APP_INFO = 'GET_APP_INFO';
export const GET_APP_PENDING_INVITE = 'GET_APP_PENDING_INVITE';
